<template>
  <div class="validator-process">
    <div class="title">
      Validator Deployment Process
    </div>
    <div class="process-items">

      <div class="item">
        <div class="item-title">
          1.Deposit
        </div>
        <div class="item-desc">
          Deposit 8 ETH to register as a delegated validator on StaFi, StaFi Staking Contract will match 24 ETH to your node so that it can meet the validator requirements of ETH2.0.
        </div>
      </div>

      <div class="item">
        <div class="item-title">
          2.Stake
        </div>
        <div class="item-desc">
          Once 32ETH is matched to your node, you can deploy a pool contract to deposit 32ETH to the Deposit contract on ETH1.0, and then wait for validation progress on ETH2.0.
        </div>
      </div>

      <div class="item">
        <div class="item-title">
          3.Status
        </div>
        <div class="item-desc">
          There is nothing we can do in this step, once you stake, we should wait for the queen, check the status on the dashboard.
        </div>
      </div>

    </div>

    <div class="start-btn" @click="$emit('validatorStart')">
      Start
    </div>

  </div>
</template>

<script>

export default {
  name: 'validatorProcess',
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang
    }
  }
};
</script>

<style lang="scss">

.validator-process {
  .title {
    text-align: center;
  }

  .process-items {
    margin-top: 15px;

    .item {
      margin-bottom: 30px;

      .item-title {
        font-size: 20px;
        font-weight: bold;
      }

      .item-desc {
        font-size: 16px;
        color: #C4C4C4;
        margin-top: 11px;
      }
    }
  }

  .start-btn {
      cursor: pointer;
      margin-left: 361px;
      width: 110px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 21px;
      text-align: center;
      margin-top: 41px;
    }
}
  
</style>